<template>
  <v-container fluid class="pa-0" style="height: 100%">
    <v-card flat class="rounded-0">

      <v-container class="d-flex pl-2 pr-4 py-2">
        <v-row no-gutters>
          <v-col cols="auto">
            <v-btn v-if="closable" color="close" class="mr-2" icon @click="close()">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
          </v-col>
          <v-col :cols="0" :class="!closable ? 'mx-3' : 'mr-4'">
            <v-text-field v-model="listfilter" single-line dense clearable hide-details
              :label="$t('servicesystem.common_objects.commonterms.filter')" />
          </v-col>
          <v-col cols="auto" v-if="newable" class="d-flex justify-end align-center">
            <v-btn @click="createnew()" small color="primary">
              <v-icon size="17" class="mr-1">mdi-plus</v-icon>{{ $t('servicesystem.common_objects.commonterms.new') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>

      <QScroll :height="listheight" :list="filteredList" :loading="loading" :skeletonloading="true">

        <template slot="list-item" slot-scope="{ item }">
          <AddressListItem :item="item" :isSelected="isTheSameAddress(Selected, item)" :showEdit="showEdit"
            @Select="select(item)" @Edit="$emit('Edit', item)">
          </AddressListItem>
        </template>

        <template slot="skeleton-loader">
          <v-skeleton-loader type="list-item-avatar" class="address">
          </v-skeleton-loader>
        </template>

      </QScroll>
    </v-card>
  </v-container>
</template>


<script>
import Vue from "vue";
import clientAPI from "@/api/ClientAPIMixin.js";
import QScroll from "@/components/Sections/Containers/QScroll.vue";
import AddressListItem from "@/components/ListItems/AddressListItem.vue";

export default {
  name: "AddressList",
  props: {
    CustomerId: [String, Number],
    Selected: [String, Number, Object],
    closable: {
      default: true,
      type: Boolean,
    },
    showEdit: Boolean,
    listheight: {
      default: 300,
      type: Number,
    },
  },
  components: {
    QScroll,
    AddressListItem,
  },
  mixins: [clientAPI],

  data: () => ({
    list: [],
    listfilter: null,
    loading: false,
  }),

  mounted() {
    this.getAddresses();
  },

  methods: {
    getAddressText(address) {
      return [address.Street, address.Zip, address.City, address.Country].join(" ");
    },

    getErpText() {
      //no point in showing on standalone, ever.
      return this.ERPBaseAssembly == 'Standalone' ? '' : this.ERPFriendlyName;
    },

    getAddresses() {
      if (this.CustomerId) {
        this.loading = true;
        this.getCustomerAdressesByCustomerId(this.CustomerId)
          .then((response) => {
            this.list = response;
            this.$emit("EmitList", response);
            //console.log(response);
          })
          .catch((response) => {
            console.error("getAddresses error", response);
          })
          .finally(() => {
            this.loading = false;
          });
        /*
        if (!this.Selected) {
          this.SelectDefault();
        }
        */
      }
    },

    SelectDefault() {
      this.select(this.list[0]);
    },

    close() {
      this.$emit("Close");
    },

    isTheSameAddress(a, b) {
      if (!a || !b) {
        return false;
      }
      if (a.Id === b.Id) {
        return true;
      }
      else if ((a.Street == b.Street) && (a.Zip == b.Zip) && (a.City == b.City) && (a.Country == b.Country)) {
        return true;
      }
      else {
        return false;
      }
    },

    select(item) {
      if (this.isTheSameAddress(this.Selected, item)) {
        this.close();
      }
      else {
        this.$emit("Select", item);
      }
    },

    createnew() {
      this.$emit("New");
    },

    updateItem(item) {
      var index = this.list.findIndex((x) => x.Id == item.Id);
      if (index < 0) {
        index = this.list.length;
      }
      Vue.set(this.list, index, item);
    },

    allowChangeAddress(address) {
      var userAllowed = this.checkPermission("Actions", "editCustomerAddress");
      var id = address?.Id;
      var isDefault = this.addressIdIsDefaultForCustomer(id) || !id;
      var isExternal = this.addressIdIsFromErp(id);
      var isLocal = !isDefault && !isExternal;
      var isReadOnly = (isDefault && this.CustomerReadonly) || (isExternal && this.CustomerAddressReadonly) || (isLocal && this.CustomerAddressLocalReadonly);
      //console.log('AllowChangeAddress', userAllowed, address, id, isDefault, isExternal, isReadOnly);
      return userAllowed && !isReadOnly;
    },

    getAddressIcon(address) {
      var id = address?.Id;
      if (this.addressIdIsDefaultForCustomer(id) || !id) {
        return 'mdi-home-map-marker';
      } else if (this.addressIdIsFromErp(id)) {
        return 'mdi-map-marker';
      } else {
        return 'mdi-map-marker-outline';
      }
    },
  },

  computed: {
    filteredList() {
      if (this.listfilter) {
        return this.list.filter((v) =>
          v && v.MetaString ? v.MetaString.toUpperCase().includes(this.listfilter.toUpperCase()) : null
        );
      } else {
        return this.list;
      }
    },

    newable() {
      // Can create if either ERP or local creation is allowed
      return (this.CustomerAddressCanCreateInErp || this.CustomerAddressCanCreateLocal) && this.checkPermission("Actions", "createCustomerAddress");
    },
  },

  watch: {
    CustomerId: function () {
      this.getAddresses();
    },
  },
};
</script>


<style lang="scss">
.v-skeleton-loader.address .v-skeleton-loader__list-item-avatar {
  height: 40px !important;
}

.v-skeleton-loader.address .v-skeleton-loader__list-item-avatar .v-skeleton-loader__avatar {
  height: 25px !important;
  width: 25px !important;
}
</style>